import React, { useEffect } from "react";
import AOS from "aos";
import { profile } from "../data/profile";
import "../App.css";

function About() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section id="about" className="site-section site-section--surface">
      <div className="container site-section-inner">
        <header className="section-head">
          {/* <p className="section-eyebrow">Introduction</p> */}
          <h2 className="section-title">About me</h2>
          <p className="section-lead">
            Engineer focused on reliable backends, cloud systems, and practical AI.
          </p>
        </header>

        <div className="about-layout">
          <div className="about-prose" data-aos="fade-up">
            {profile.bio.map((paragraph) => (
              <p key={paragraph.slice(0, 32)}>{paragraph}</p>
            ))}
          </div>
          <div className="about-portrait-wrap" data-aos="fade-up" data-aos-delay="80">
            <div className="about-portrait-frame">
              <img
                src={profile.portrait}
                className="about-portrait"
                alt={profile.name}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
